import {get} from 'lodash'
import {takeFirstDefinedForKeys} from 'powtoon-commons/utils'

const webvars = window.webvars || {}
const assignedWebVars = takeFirstDefinedForKeys({
  userName:                          [ webvars.username, '' ],
  userid:                            [ webvars.userid, 123 ],
  apiHost:                           [ process.env.API_HOST, webvars.api_host, '' ],
  showPreview:                       [ webvars.show_preview, false ],
  isNewUser:                         [ webvars.is_new_user, false ],
  segment:                           [ webvars.segment, 'work' ],
  usecase:                           [ webvars.use_case, '' ],
  savingInterval:                    [ webvars.saving_interval_sec, 120 ],
  cdnApiHost:                        [ webvars.CDN_API_HOST, '' ],
  startWithTemplateChooser:          [ webvars.start_with_template_chooser, false ],
  skipSBForEmptyTemplate:            [ webvars.skip_sb_for_empty_template, false ],
  goToEditorAfterTemplatePopulate:   [ webvars.go_to_editor_after_template_populate, false ],
  goToEditorAfterTemplateChosen:     [ webvars.go_to_editor_after_template_chosen, false ],
  studioReadyEventName:              [ webvars.studioReadyEventName, 'studio-loading-finished' ],
  setBasicSturctureForEmptyTemplate: [ webvars.set_basic_structure_for_empty_template, true ],
  contentPermissionId:               [ webvars.content_permission_id, '' ],
  isStoryboardHtmlStudio:            [ webvars.is_storyboard_html_studio, false ],
  show5LooksScreen:                  [ webvars.show_5_looks_screen, false ],
  locksOnSceneGift:                  [ webvars.locks_on_scene_gift, 'none' ],
  startWithSquareMode:               [ webvars.start_with_square_mode, false ],
  showSceneWatermark:                [ webvars.show_scene_watermark, false ],
  abOptInTrial:                      [ webvars.ab_opt_in_trial, false ],
  showMobileAppPromotion:            [ webvars.enable_mobile_app_promotion, false ],
  isProdEnv:                         [ webvars.IS_PROD_ENV, false ],
  isStagingEnv:                      [ webvars.IS_STAGING_ENV, false ],
  isEnterprise:                      [ webvars.is_enterprise, false ],
  pusherKey:                         [ process.env.PUSHER_KEY, webvars.PUSHER_KEY ],
  logzio_id:                         [ webvars.logzio_id, null ],
  min_log_level:                     [ webvars.min_log_level, null ],
  embeddedSessionId:                 [ webvars.embedded_session_id, null ],
  hideNameField:                     [ get(webvars, ['app_settings', 'hide_name_field']), null ],
  hideUpgradeButton:                 [ webvars.hide_upgrade_button, false ],
  hideQuickMenu:                     [ get(webvars, ['app_settings', 'hide_quick_menu']), null ],
  customExportLabel:                 [ get(webvars, ['app_settings', 'custom_export_label']), null ],
  customPublishUrlFormat:            [ get(webvars, ['app_settings', 'custom_publish_url_format']), null],
  disableExternalLinks:              [ get(webvars, ['app_settings', 'disable_external_links']), null ],
  enableWochit:                      [ !!webvars.enable_wochit, false ],
  wochitProviderId:                  [ webvars.wochit_provider_id, null ],
  appLevel:                          [ webvars.APP_LEVEL, null ],
  fontsUploadRequiredPlan:           [ webvars.fonts_upload_required_plan, 'agency_yearly' ],
  predefinedPlan:                    [ webvars.predefined_plan, '' ],
  enableFontsUpload:                 [ webvars.enable_fonts_upload, false ],
  enableNewModeSwitcher:             [ webvars.enable_new_mode_switcher, true ],
  abMode:                            [ webvars.ab_mode, 'test', null ],
  useCanvasPlayer:                   [ webvars.use_canvas_player, false],
  enableDynamicFeatures:             [ webvars.enable_dynamic_features, false],
  clientIP:                          [ webvars.client_ip, null ],
  isDashPanelEnabled:                [ webvars.enable_pt_features, false ],
  isLocalEnv:                        [ process.env.NODE_ENV === 'development', false ],
  enableSoundEffect:                 [ webvars.enable_sound_effect, false],
  enabledNewDashboard:               [ webvars.enabled_new_dashboard, false],
  publicLinkEnabled:                 [ webvars.public_link_enabled, true],
  enableWebCamRecord:                [ webvars.enable_web_cam_record, true]
})

export default {
  getWebVars: () => assignedWebVars,
  getWebVar: propName => assignedWebVars[propName]
}
